import { saveAs } from 'file-saver';

export interface BlobExportFile {
  filename: string;
  content: Blob | string;
}

export const saveFile = (file: BlobExportFile): void => {
  const filename = sanitizeFilename(file.filename);
  saveAs(file.content, filename);
};

const sanitizeFilename = (filename: string) => {
  return filename.replace(/[^a-z0-9\s.-]/gi, '_');
};
